(function() {
  if (window.__tgmCartAddWired) return;
  window.__tgmCartAddWired = true;

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getSections(cart) {
    if (cart && typeof cart.getSectionsToRender === 'function') {
      return cart.getSectionsToRender().map(function(section) { return section.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function setButtonState(button, label, text, busy) {
    if (label) label.textContent = text;
    if (!button) return;
    button.toggleAttribute('disabled', busy);
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
    button.setAttribute('aria-disabled', busy ? 'true' : 'false');
  }

  function resetButton(button, label, originalText, delay) {
    window.setTimeout(function() {
      setButtonState(button, label, originalText, false);
    }, delay);
  }

  document.addEventListener('submit', function(event) {
    var form = event.target.closest('[data-tgm-add-form]');
    if (!form) return;
    event.preventDefault();

    var button = form.querySelector('[data-tgm-add-btn]');
    if (button && button.getAttribute('aria-busy') === 'true') return;

    var label = form.querySelector('[data-tgm-add-label]');
    var originalText = form.getAttribute('data-default-label') || (label ? label.textContent.trim() : 'Add');
    var cart = getCartDrawer();
    var formData = new FormData(form);

    // Always wipe all selling_plan entries that FormData collected (the hidden
    // placeholder has value="" and would override the subscription radio).
    // Then re-add only when a subscription radio is actually checked.
    formData.delete('selling_plan');
    var checkedPlan = form.querySelector('[name="selling_plan"]:checked');
    if (checkedPlan && checkedPlan.value) {
      formData.append('selling_plan', checkedPlan.value);
    }

    formData.append('sections', getSections(cart));
    formData.append('sections_url', window.location.pathname);
    if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(button || form);

    setButtonState(button, label, 'Adding...', true);

    fetch(window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function(response) { return response.json(); })
      .then(function(response) {
        if (response.status) throw response;

        setButtonState(button, label, 'Added', true);
        if (cart && typeof cart.renderContents === 'function') {
          cart.classList.remove('is-empty');
          cart.renderContents(response);
        } else {
          var cartTrigger = document.querySelector('#cart-icon-bubble, .header__icon--cart');
          if (cartTrigger) cartTrigger.click();
        }
        resetButton(button, label, originalText, 1500);
      })
      .catch(function(error) {
        setButtonState(button, label, 'Try again', true);
        resetButton(button, label, originalText, 2000);
        if (window.ErrorHandler && typeof window.ErrorHandler.logError === 'function') {
          window.ErrorHandler.logError(error, 'tgm-cart-add');
        }
      });
  });
})();
